import React, {useEffect, useState} from "react";

import "./profileMenu.css";

import ShareIcon from "../../../../assets/icon/Share.svg";
import PrizeIcon from "../../../../assets/icon/Prizes.svg";
import TermIcon from "../../../../assets/icon/Terms.svg";
import SettingIcon from "../../../../assets/icon/Settings.svg";
import SupportIcon from "../../../../assets/icon/Support.svg";
import LogoutIcon from "../../../../assets/icon/Logout.svg";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {offerEligibility, userLogout} from "../../../../services/MainApiDetails";
import { Link } from "react-router-dom";

const ProfileMenu = () => {

  function logoutUser() {
    userLogout()
      .then((res) => {
        sessionStorage.clear();
        localStorage.clear();
        window.location.href = "/";
      })
      .catch((e) => {
        console.log(e);
      });
  }


  return (
    <div className="profileMenu">

      <div className="profileMenu-wrapper">
        {/* <div className="profileMenu-option">
          <Link to="/mobile-prizes">
            <div className="profileMenu-part1">
              <div className="profileMenu-img">
                <img src={PrizeIcon} alt="" />
              </div>
              <div className="profileMenu-text">
                <p>Prizes</p>
              </div>
            </div>
            <div className="profileMenu-part2">
              <div className="arrow-img">
                <ArrowForwardIosIcon className="icon" />
              </div>
            </div>
          </Link>
        </div> */}

        <div className="profileMenu-option">
          <Link to="/mobile-terms-conditions">
            <div className="profileMenu-part1">
              <div className="profileMenu-img">
                <img src={TermIcon} alt="" />
              </div>
              <div className="profileMenu-text">
                <p>Terms and conditions</p>
              </div>
            </div>
            <div className="profileMenu-part2">
              <div className="arrow-img">
                <ArrowForwardIosIcon className="icon" />
              </div>
            </div>
          </Link>
        </div>

        <div className="profileMenu-option">
          <Link to="/mobile-settings">
            <div className="profileMenu-part1">
              <div className="profileMenu-img">
                <img src={SettingIcon} alt="" />
              </div>
              <div className="profileMenu-text">
                <p>Settings</p>
              </div>
            </div>
            <div className="profileMenu-part2">
              <div className="arrow-img">
                <ArrowForwardIosIcon className="icon" />
              </div>
            </div>
          </Link>
        </div>

        <div className="profileMenu-option" >
          <Link to="/mobile-support">
            <div className="profileMenu-part1">
              <div className="profileMenu-img">
                <img src={SupportIcon} alt="" />
              </div>
              <div className="profileMenu-text">
                <p>Support</p>
              </div>
            </div>
            <div className="profileMenu-part2">
              <div className="arrow-img">
                <ArrowForwardIosIcon className="icon" />
              </div>
            </div>
          </Link>
        </div>
        {!localStorage.is_mobile ? (
          <button className="profileMenu-option"onClick={logoutUser}>
            <div className="profileMenu-part1">
              <div className="profileMenu-img">
                <img src={LogoutIcon} alt="" />
              </div>
              <div className="profileMenu-text">
                <p>Logout</p>
              </div>
            </div>
            <div className="profileMenu-part2">
              <div className="arrow-img">
                <ArrowForwardIosIcon className="icon" />
              </div>
            </div>
          </button>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default ProfileMenu;
